var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1742_906)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#3B3B3C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1254 11.8V10.252H40.0174V19H38.2894V11.8H37.1254ZM41.6771 14.512C41.6771 13.128 41.9251 12.044 42.4211 11.26C42.9251 10.476 43.7571 10.084 44.9171 10.084C46.0771 10.084 46.9051 10.476 47.4011 11.26C47.9051 12.044 48.1571 13.128 48.1571 14.512C48.1571 15.904 47.9051 16.996 47.4011 17.788C46.9051 18.58 46.0771 18.976 44.9171 18.976C43.7571 18.976 42.9251 18.58 42.4211 17.788C41.9251 16.996 41.6771 15.904 41.6771 14.512ZM46.5011 14.512C46.5011 13.92 46.4611 13.424 46.3811 13.024C46.3091 12.616 46.1571 12.284 45.9251 12.028C45.7011 11.772 45.3651 11.644 44.9171 11.644C44.4691 11.644 44.1291 11.772 43.8971 12.028C43.6731 12.284 43.5211 12.616 43.4411 13.024C43.3691 13.424 43.3331 13.92 43.3331 14.512C43.3331 15.12 43.3691 15.632 43.4411 16.048C43.5131 16.456 43.6651 16.788 43.8971 17.044C44.1291 17.292 44.4691 17.416 44.9171 17.416C45.3651 17.416 45.7051 17.292 45.9371 17.044C46.1691 16.788 46.3211 16.456 46.3931 16.048C46.4651 15.632 46.5011 15.12 46.5011 14.512ZM53.5629 19L51.3069 16.168V19H49.6269V10.12H51.3069V15.172L53.5389 12.352H55.7229L52.7949 15.688L55.7469 19H53.5629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.307 20.9194C26.3614 20.9266 26.4159 20.934 26.4703 20.9417L26.7438 20.9801C27.9346 21.1472 29 20.2395 29 19.0579V18.1562C29 17.3111 28.4592 16.5573 27.649 16.2731C26.7129 15.9447 25.7466 15.7309 24.7711 15.6316C25.789 16.3675 26.4203 17.5592 26.4203 18.8594V19.979C26.4203 20.3041 26.3809 20.619 26.307 20.9194ZM22.1812 14.432C22.5868 14.5995 23.0324 14.692 23.5 14.692C25.3813 14.692 26.9064 13.1939 26.9064 11.346C26.9064 9.49801 25.3813 7.99994 23.5 7.99994C23.4443 7.99994 23.3889 8.00125 23.3338 8.00385C23.6759 8.73246 23.8671 9.546 23.8671 10.4042C23.8671 11.9807 23.2219 13.4065 22.1812 14.432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0739 20.9194C10.0194 20.9266 9.96499 20.934 9.91058 20.9417L9.63707 20.9801C8.44625 21.1472 7.38084 20.2395 7.38084 19.0579V18.1562C7.38084 17.3111 7.92166 16.5573 8.73185 16.2731C9.66791 15.9447 10.6343 15.7309 11.6098 15.6316C10.5919 16.3675 9.96057 17.5592 9.96057 18.8594V19.979C9.96057 20.3041 9.99992 20.619 10.0739 20.9194ZM14.1997 14.432C13.7941 14.5995 13.3485 14.692 12.8808 14.692C10.9995 14.692 9.47442 13.1939 9.47442 11.346C9.47442 9.49801 10.9995 7.99994 12.8808 7.99994C12.9366 7.99994 12.992 8.00125 13.0471 8.00385C12.705 8.73246 12.5138 9.546 12.5138 10.4042C12.5138 11.9807 13.159 13.4065 14.1997 14.432Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3671 10.4042C22.3671 8.10986 20.5071 6.24994 18.2128 6.24994C15.9185 6.24994 14.0586 8.10986 14.0586 10.4042C14.0586 12.6985 15.9185 14.5584 18.2128 14.5584C20.5071 14.5584 22.3671 12.6985 22.3671 10.4042Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.153 16.5214C16.425 15.3528 20.0006 15.3528 23.2727 16.5214C24.2607 16.8743 24.9203 17.8102 24.9203 18.8594V19.979C24.9203 21.4459 23.621 22.5728 22.1687 22.3654L21.8351 22.3177C19.4325 21.9745 16.9932 21.9745 14.5905 22.3177L14.2569 22.3654C12.8047 22.5728 11.5054 21.4459 11.5054 19.979V18.8594C11.5054 17.8102 12.1649 16.8743 13.153 16.5214Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1742_906",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1742_906"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1742_906",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayers);
export default __webpack_public_path__ + "static/media/Players.15ca995c8eed83c9242cbf31cbdf6e5b.svg";
export { ForwardRef as ReactComponent };